import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    Divider,
    colors,
    Button
} from '@material-ui/core';

import {
    Alert
} from '@material-ui/lab';

import {
    FieldError
} from '../../../common';

import {
    ResetSettingsDialog
} from './Dialogs';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    Switch,
    TextField,
    CheckboxWithLabel
} from 'formik-material-ui';

import { PageContext } from '../PageContext';

import { getColoredBottonStyle } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    resetButton: {
        ...getColoredBottonStyle(theme, colors.red)
    },
}));

export const SettingsForm = ({
    formRef,
    errors,
    validationSchema,
    reset,
    disabled,
    onBlur,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const [openResetDialog, setOpenResetDialog] = useState(false);

    const {
        state
    } = useContext(PageContext);

    const {
        settings
    } = state;

    const getInitialValues = () => {
        return {};
    }

    const resetClickHandler = (e) => {
        setOpenResetDialog(true);
    }

    const confirmResetHandler = () => {
        setOpenResetDialog(false);
        if (reset) reset();
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardContent>
                <Container maxWidth="lg" className={classes.content}>
                    <Formik
                        enableReinitialize
                        initialValues={getInitialValues()}
                        onSubmit={submitClickHandler}
                        innerRef={formRef}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={true}
                        validate={(values) => {
                            if (onBlur) onBlur(values);
                        }}>
                        {(props) => {
                            const {
                                values,
                                isSubmitting,
                                handleSubmit,
                                setFieldValue
                            } = props;
                            return (
                                <Form noValidate autoComplete="off">
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography variant="h5" component="h2">
                                                {t("LabelResetSettings")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography>
                                                {t("LabelResetSettingsHelp")}
                                            </Typography>
                                            <br />
                                            <Button
                                                className={classes.resetButton}
                                                disabled={disabled}
                                                onClick={resetClickHandler}>
                                                {t("ButtonResetSettings")}
                                            </Button>
                                        </Grid>

                                    </Grid>

                                    <ResetSettingsDialog
                                        open={openResetDialog}
                                        onConfirm={(e) => confirmResetHandler()}
                                        onClose={(e) => setOpenResetDialog(false)}
                                    />

                                </Form>
                            );
                        }}
                    </Formik>
                </Container>
            </CardContent>
        </Card>
    );
}